import {HasAvatar} from 'ui-library/avatar/Avatar';

export function getPartyDisplayString(party: HasAvatar): string | undefined {
  return party.name || party.handle;
}
